import { IFileSource, IMapping, IMappingDetail, IMappingVersion, IRawMetaData, IStep } from "@samc/centricity-core";

export interface IEnrichmentImportData {
  enrichment: string | null;
  currentData: string | null;
}

export interface IDataImportAutosaveBlob {
  extraParams?: Record<string, string> | null;
  fileSource?: IFileSource | null;
  metadata?: IRawMetaData | null;
  basicMetadata?: IRawMetaData | null;
  step?: string | null;
  mapping?: IMapping<IMappingDetail> | null;
  mappingVersion?: IMappingVersion | null;
  currentStep?: IStep | null;
  steps?: IStep[] | null;
  enrichmentData?: IEnrichmentImportData | null;
  syncAutoSave?: boolean | null;
}

export const DataImportAutosaveTask = "Data Import";